import moment from 'moment'
const format = 'MMM DD, YYYY HH:mm:ss'

import { RootState, IlogicalState, Module } from '../types'
import { Logical, Request } from '@/types/logical'

import io from '@/socket.io'

import * as api from '@/api/logical'

// let subscribed = false
export const logical: Module<IlogicalState, RootState> = {
  namespaced: true,

  state() {
    return {
      initialize: false,
      items: [],
    }
  },

  getters: {
    initialize: (state) => state.initialize,

    navs: (state) => {
      return state.items.filter((logical) => logical.deletedAt == null)
    },

    functions: (state) => {
      return state.items.filter((logical) => logical.type === 'function')
    },

    deleted: (state) => {
      return state.items.filter((logical) => logical.deletedAt != null)
    },
  },

  mutations: {
    SET_INITIALIZE(state, payload: boolean) {
      state.initialize = payload
    },

    SET_ITEMS(state, payload: Logical[]) {
      payload.map((item) => {
        if (item.deletedAt) {
          item.deletedAt = moment(item.deletedAt).format(format)
        }
      })

      state.items = payload
    },
  },

  actions: {
    async subscribe(): Promise<void> {
      io.emit('subscribe-logical')
    },

    async unsubscribe(): Promise<void> {
      io.emit('unsubscribe-logical')
    },

    async runtime(_, d: Request): Promise<string> {
      return await api.Runtime(d)
    },

    async find({ commit }): Promise<void> {
      const items = await api.Find()
      commit('SET_ITEMS', items)
      commit('SET_INITIALIZE', true)
    },

    async findV(_, p: Request): Promise<Array<Logical>> {
      return await api.Find(p)
    },

    async get(_, d: string): Promise<object> {
      return await api.Get(d)
    },

    async create({ dispatch }, d: Request): Promise<void> {
      await api.Post(d)
      await dispatch('find')
    },

    async patch({ dispatch }, d: Request): Promise<void> {
      await api.Patch(d)
      await dispatch('find')
    },

    async delete({ dispatch }, d: Request): Promise<void> {
      await api.Delete(d)
      if (!d.ver) {
        await dispatch('find')
      }
    },
  },
}
